import React from 'react';
import { ExplorerItem } from './types';
interface CompactRowProps {
  item: ExplorerItem;
  onClick: () => void;
  accentColor?: 'blue' | 'purple';
}
export function CompactRow({
  item,
  onClick,
  accentColor = 'blue'
}: CompactRowProps) {
  const Icon = item.icon;
  const isActive = item.usageCount > 0;
  const accentClass = accentColor === 'blue' ? 'text-blue-600 bg-blue-50' : 'text-purple-600 bg-purple-50';
  const hoverClass = accentColor === 'blue' ? 'hover:border-blue-300' : 'hover:border-purple-300';
  const countClass = accentColor === 'blue' ? 'text-blue-600' : 'text-purple-600';
  return <div onClick={isActive ? onClick : undefined} className={`flex items-center justify-between px-2.5 sm:p-3 py-2 sm:py-3 rounded-lg border transition-all gap-2 ${isActive ? `bg-white border-gray-200 cursor-pointer ${hoverClass} hover:shadow-sm` : 'bg-gray-50/50 border-gray-100 opacity-60 cursor-not-allowed'}`} data-id="element-6072">
      <div className="flex items-center gap-2.5 sm:gap-4 min-w-0 flex-1" data-id="element-6073">
        <div className={`w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center shrink-0 ${isActive ? accentClass : 'bg-gray-200 text-gray-400'}`} data-id="element-6074">
          <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-6075" />
        </div>
        <div className="min-w-0 flex-1" data-id="element-6076">
          <div className="flex items-center gap-1.5 sm:gap-2 min-w-0" data-id="element-6077">
            <code className="text-xs sm:text-sm font-mono font-bold text-gray-900 truncate" data-id="element-6078">
              {item.id}
            </code>
            {!item.isRegistered && <span className="text-[9px] sm:text-[10px] bg-red-100 text-red-700 px-1 sm:px-1.5 py-0.5 rounded font-bold shrink-0" data-id="element-6079">
                Unreg
              </span>}
          </div>
          <p className="text-[11px] sm:text-xs text-gray-500 line-clamp-1" data-id="element-6080">
            {item.description}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-6 shrink-0" data-id="element-6081">
        {/* Module badges — visible on tablet+ */}
        <div className="hidden md:flex flex-wrap gap-1 justify-end max-w-[10rem]" data-id="element-6082">
          {Array.from(item.modules).slice(0, 3).map(m => <span key={m} className="text-[10px] font-bold px-1.5 py-0.5 rounded border bg-gray-50 border-gray-200 text-gray-600" data-id="element-6083">
                {m}
              </span>)}
          {item.modules.size > 3 && <span className="text-[10px] text-gray-400 font-medium px-1" data-id="element-6084">
              +{item.modules.size - 3}
            </span>}
        </div>

        {/* Stats */}
        <div className="text-right min-w-[2.5rem] sm:min-w-[4rem]" data-id="element-6085">
          <div className={`text-sm font-black ${isActive ? countClass : 'text-gray-400'}`} data-id="element-6086">
            {item.usageCount}
          </div>
          <div className="text-[10px] text-gray-500 font-medium" data-id="element-6087">refs</div>
        </div>
      </div>
    </div>;
}